import Layout from '../../Shared/Layout'
import ValidateurOrdres from './ValidateurOrdres'
import ValidateurCompte from './ValidateurCompte'

function GlobalValidateur() {
  return (
    <Layout>
      <div className="content-body default-height">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
                <div className="row">
                  <ValidateurOrdres />
                    <div className='mt-5'></div>
                  <ValidateurCompte />
                </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default GlobalValidateur